import { Component, CUSTOM_ELEMENTS_SCHEMA, Inject } from '@angular/core';

import { EventNotificationsServiceBase } from '@skylab-shared/business';
import { ImportClientsIdentification, LabeledEnumValue, LabeledEnumValueConverter } from '@skylab-shared/dataModel';
import { ToastDelay } from '@skylab-shared/ui';

import { EventNotificationsService, ImportRepository, ImportRepositoryBase } from '@skylab-angular-shared/business';
import { EnumTranslator, EnumTranslatorBase, L10n, L10nBase } from '@skylab-angular-shared/core';
import { ButtonComponent, DialogContentComponentIns, DialogHeaderComponentIns, DialogInsService, DialogState, FilepickerInsComponent, FocusByDirective, FormContainerComponent, PasswordComponentIns, SelectValueAccessorDirective, ToastService, TooltipDirective, IconComponent } from '@skylab-angular-shared/ui';

import { NgClass } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslatePipe } from '@skylab-angular-shared/pipes';
import { ImportDialogBase, ImportViewModel } from '../import-dialog-base';

export interface ImportClientsViewModel extends ImportViewModel {
    identificationKind: ImportClientsIdentification;
    identificationKinds: LabeledEnumValue[];
    identificationKindValueConverter: LabeledEnumValueConverter<ImportClientsIdentification>;
}

@Component({
    selector: 'skl-import-clients-dialog',
    templateUrl: './clients-import-dialog.component.html',
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    imports: [DialogContentComponentIns, DialogHeaderComponentIns, FormContainerComponent, FocusByDirective, FilepickerInsComponent, PasswordComponentIns, FormsModule, NgClass, TooltipDirective, SelectValueAccessorDirective, ButtonComponent, TranslatePipe, IconComponent]
})
export class ImportClientsDialogComponent extends ImportDialogBase<ImportClientsViewModel> {

    public constructor(
        @Inject(EnumTranslator) enumTranslator: EnumTranslatorBase,
        @Inject(ImportRepository) importRepository: ImportRepositoryBase,
        dialogService: DialogInsService,

        private readonly toastService: ToastService,
        @Inject(L10n) private readonly l10n: L10nBase,
        @Inject(EventNotificationsService) private readonly eventNotifications: EventNotificationsServiceBase,
    ) {
        super(enumTranslator, importRepository, dialogService);
    }

    protected override getInitialState(): ImportClientsViewModel {
        return {
            ...super.getInitialState(),
            identificationKinds: this.enumTranslator.getLabeledEnumValueArray(ImportClientsIdentification),
            identificationKind: ImportClientsIdentification.Name,
            identificationKindValueConverter: new LabeledEnumValueConverter(this.enumTranslator, ImportClientsIdentification)
        };
    }

    protected async postImportRequestAsync(data: FormData): Promise<{ isSuccessfull: boolean, data: unknown }> {
        return await this.importRepository.importClientsAsync(data, {
            duplicates: this.viewModel.handleDuplicate,
            identification: this.viewModel.identificationKind
        });
    }

    protected onImportSuccess(response: { isSuccessfull: boolean, data: unknown }): boolean {
        const _T = this.l10n._T;

        this.toastService.showAsync({
            type: 'success',
            duration: ToastDelay.VeryLong,
            text: _T('scenes.dialogs.clients-import.messages.success')
        });

        this.eventNotifications.refreshInterval('imports');
        this.dialogService.close({ state: DialogState.Confirm });
        return true;
    }

    protected onImportError(reason: unknown): boolean {
        const _T = this.l10n._T;

        this.toastService.showAsync({
            type: 'error',
            duration: ToastDelay.None,
            text: _T('scenes.dialogs.clients-import.messages.error'),
        });

        this.dialogService.close({ state: DialogState.Cancel });
        return true;
    }
}
